import { CheckoutConfig } from '../../../types';

export interface StylePreset {
  id: string;
  name: string;
  category: string;
  primaryColor: string;
  backgroundColor: string;
  textColor: string;
  fontFamily: string;
  buttonRadius: string;
  inputStyle: 'outline' | 'solid';
}

export const STYLE_PRESETS: StylePreset[] = [
  {
    id: 'modern-indigo',
    name: 'Modern Indigo',
    category: 'SaaS Light',
    primaryColor: '#4f46e5',
    backgroundColor: '#ffffff',
    textColor: '#0f172a',
    fontFamily: 'Inter',
    buttonRadius: '8px',
    inputStyle: 'outline',
  },
  {
    id: 'supabase-emerald',
    name: 'Obsidian Emerald',
    category: 'Dark Tech',
    primaryColor: '#10b981',
    backgroundColor: '#090d16',
    textColor: '#f8fafc',
    fontFamily: 'Space Grotesk',
    buttonRadius: '10px',
    inputStyle: 'solid',
  },
  {
    id: 'midnight-violet',
    name: 'Midnight Violet',
    category: 'Dark Tech',
    primaryColor: '#8b5cf6',
    backgroundColor: '#0c0e1a',
    textColor: '#ffffff',
    fontFamily: 'Outfit',
    buttonRadius: '12px',
    inputStyle: 'solid',
  },
  {
    id: 'stripe-executive',
    name: 'Stripe Classic',
    category: 'Enterprise',
    primaryColor: '#6366f1',
    backgroundColor: '#f8fafc',
    textColor: '#1e293b',
    fontFamily: 'Inter',
    buttonRadius: '6px',
    inputStyle: 'outline',
  },
  {
    id: 'sunset-amber',
    name: 'Sunset Amber',
    category: 'Warm Creative',
    primaryColor: '#d97706',
    backgroundColor: '#fffbeb',
    textColor: '#451a03',
    fontFamily: 'Plus Jakarta Sans',
    buttonRadius: '16px',
    inputStyle: 'outline',
  },
  {
    id: 'cyber-neon',
    name: 'Cyber Cyan',
    category: 'High-Tech',
    primaryColor: '#06b6d4',
    backgroundColor: '#020617',
    textColor: '#38bdf8',
    fontFamily: 'monospace',
    buttonRadius: '0px',
    inputStyle: 'solid',
  },
  {
    id: 'nordic-slate',
    name: 'Nordic Clean',
    category: 'Minimalist',
    primaryColor: '#0f172a',
    backgroundColor: '#ffffff',
    textColor: '#0f172a',
    fontFamily: 'Inter',
    buttonRadius: '8px',
    inputStyle: 'outline',
  },
  {
    id: 'rose-boutique',
    name: 'Rose Premium',
    category: 'Warm Creative',
    primaryColor: '#e11d48',
    backgroundColor: '#fff1f2',
    textColor: '#881337',
    fontFamily: 'Outfit',
    buttonRadius: '14px',
    inputStyle: 'outline',
  },
];
